import $axios from '../services/apiLms.js'
import cookie from 'vue-cookie'

const state = () => ({
    student_me: {},
})

const mutations = {
    ASSIGN_STUDENT_ME(state, payload) {
        state.student_me = payload
    },    
}

const actions = {
    getStudentMe({ commit }) {
        return new Promise((resolve) => {
           $axios.post(`/ortu/me`)
                .then((response) => {
                    commit('ASSIGN_STUDENT_ME', response.data.data)
                    commit('SET_STUDENT_NAME', response.data.data.nama, { root: true })
                    commit('SET_STUDENT_IMAGE', response.data.data.url_photo, { root: true })
                    commit('SET_STUDENT_CLASSROOM', `${response.data.data.class.nama} - ${response.data.data.classroom.nama}`, { root: true })
                    cookie.set('student_name', response.data.data.nama, { expires: 1 })
                    cookie.set('student_image', response.data.data.url_photo, { expires: 1 })
                    cookie.set('student_classroom', `${response.data.data.class.nama} - ${response.data.data.classroom.nama}`, { expires: 1 })
                    resolve(response.data.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}